import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ChevronDownIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToNext = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-71">
      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none mask-image:linear-gradient(to_bottom,transparent,black,transparent)" style={{
      WebkitMaskImage: 'linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)'
    }} data-id="element-72" />

      {/* Abstract Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-73">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#D4AF37]/10 rounded-full blur-[120px] animate-pulse-glow" data-id="element-74" />
        <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-[#AA8C2C]/10 rounded-full blur-[150px] animate-pulse-glow" style={{
        animationDelay: '2s'
      }} data-id="element-75" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-76" />

        {/* Floating Geometric Shapes */}
        <div className="absolute top-1/3 right-1/4 w-16 h-16 border border-[#D4AF37]/20 rounded-lg rotate-12 animate-float backdrop-blur-sm" data-id="element-77" />
        <div className="absolute bottom-1/3 left-1/4 w-24 h-24 border border-white/10 rounded-full animate-float-delayed backdrop-blur-sm" data-id="element-78" />
        <div className="absolute top-1/2 left-1/6 w-12 h-12 border border-[#D4AF37]/10 rotate-45 animate-float" style={{
        animationDelay: '1s'
      }} data-id="element-79" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center flex flex-col items-center" data-id="element-80">
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full glass-card mb-8 border-[#D4AF37]/30 shadow-[0_0_15px_rgba(212,175,55,0.1)]" data-id="element-81">
          <span className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" data-id="element-82" />
          <span className="text-sm font-semibold text-[#F3E5AB] tracking-wide uppercase" data-id="element-83">
            Premium Shopify Partners
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-8 leading-[1.1]" data-id="element-84">
          Design Without <br className="hidden md:block" data-id="element-85" />
          <span className="text-gradient-gold" data-id="element-86">Limits.</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-87">
          Custom Shopify themes, high-performance apps, and conversion-focused
          stores built for premium merchants.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto mb-16" data-id="element-88">
          <Link to="/portfolio" className="w-full sm:w-auto bg-gradient-gold text-black px-8 py-4 rounded-full font-semibold text-lg gold-glow-hover transition-all duration-300 flex items-center justify-center gap-2 group hover:scale-105" data-id="element-89">
            View Our Work
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-90" />
          </Link>
          <Link to="/products" className="w-full sm:w-auto px-8 py-4 rounded-full font-semibold text-lg text-white border border-white/20 hover:border-[#D4AF37] hover:bg-white/5 transition-all duration-300 flex items-center justify-center hover:scale-105" data-id="element-91">
            Explore Products
          </Link>
        </div>

        {/* Stats Row */}
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-sm md:text-base text-gray-400 font-medium pt-8 border-t border-white/10 w-full max-w-3xl" data-id="element-92">
          <div className="flex items-center gap-2" data-id="element-93">
            <span className="text-white font-bold" data-id="element-94">1,000+</span> Stores
            Delivered
          </div>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-[#D4AF37]/50" data-id="element-95" />
          <div className="flex items-center gap-2" data-id="element-96">
            <span className="text-white font-bold" data-id="element-97">100%</span> Shopify Focused
          </div>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-[#D4AF37]/50" data-id="element-98" />
          <div className="flex items-center gap-1" data-id="element-99">
            <StarIcon className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" data-id="element-100" />
            <StarIcon className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" data-id="element-101" />
            <StarIcon className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" data-id="element-102" />
            <StarIcon className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" data-id="element-103" />
            <StarIcon className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" data-id="element-104" />
            <span className="ml-1 text-white" data-id="element-105">Premium Quality</span>
          </div>
        </div>
      </div>

      <button onClick={scrollToNext} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-gray-500 hover:text-[#D4AF37] transition-colors animate-bounce" aria-label="Scroll down" data-id="element-106">
        <ChevronDownIcon className="w-8 h-8" data-id="element-107" />
      </button>
    </section>;
}